// @ core
const apiURLBuilder = require('core/apiURLBuilder');
// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');
// @ constants
const actionTypes = require('constants/actionTypes');
// @ actions
const { requestCardStatements } = require('actions/getCardsStatements');
const { requestCardStatementDetails } = require('actions/getCardsStatementDetails');

const requestStatementMovements = statementId => ({
    type: actionTypes.FETCH_CARD_STATEMENT_MOVEMENTS_REQUEST,
    payload: {
        statementId
    }
});


const requestStatementMovementsSuccess = (data, statementId) => ({
    type: actionTypes.FETCH_CARD_STATEMENT_MOVEMENTS_SUCCESS,
    payload: {
        statementId,
        movements: get(data, 'listaMovimientosExtracto.movimiento', []),
        nextPage: get(data, '_links.nextPage.href', '')
    }
});

const requestStatementMovementsFailure = (error, statementId) => ({
    type: actionTypes.FETCH_CARD_STATEMENT_MOVEMENTS_FAILURE,
    payload: {
        statementId,
        error
    }
});

const requestNextPageRequest = statementId => ({
    type: actionTypes.FETCH_CARD_STATEMENT_MOVEMENTS_NEXT_PAGE_REQUEST,
    payload: {
        statementId
    }
});

const requestNextPageSuccess = (data, statementId) => ({
    type: actionTypes.FETCH_CARD_STATEMENT_MOVEMENTS_NEXT_PAGE_SUCCESS,
    payload: {
        statementId,
        movements: get(data, 'listaMovimientosExtracto.movimiento', []),
        nextPage: get(data, '_links.nextPage.href', '')
    }
});

const requestNextPageFailure = (error, statementId) => ({
    type: actionTypes.FETCH_CARD_STATEMENT_MOVEMENTS_NEXT_PAGE_FAILURE,
    payload: {
        statementId,
        error
    }
});

const requestNextPage = statementId => (dispatch, getState) => {
    const nextPageUrl = getState().cardsStatementMovements.getIn([statementId, 'nextPage']);

    dispatch(requestNextPageRequest(statementId));
    return APIGet({dispatch, url: nextPageUrl, endpoint: 'cardStatementMovements'})
        .then(response => dispatch(requestNextPageSuccess(response, statementId)))
        .catch(
            response => {
                if (!!response.error) {
                    dispatch(requestNextPageFailure(response.error, statementId))
                } else {
                    throw response;
                }
            }
        );
};

const fetchMovements = (cardId, statementId, dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);
    const immStatement = getState().cardsStatements.getIn([cardId, 'byId', statementId]);
    const detailsRequestData = {
        query: {
            producto: immCard.getIn(['contract', 'product']),
            numeroContrato: immCard.getIn(['contract', 'number']),
            divisa: immStatement.getIn(['amount', 'currency']),
            fechaGeneracionExtracto: immStatement.get('generationDate'),
            numeroMovimientoDia: immStatement.get('movementDay')
        }
    };

    dispatch(requestStatementMovements(statementId));
    return APIGet(dispatch, apiURLBuilder.getURL('cardStatementMovements'), detailsRequestData).then(
        response => dispatch(requestStatementMovementsSuccess(response, statementId)),
        error => dispatch(requestStatementMovementsFailure(error, statementId))
    )
};

const requestMovements = (cardId, statementId, force = false) => (dispatch, getState) =>
    dispatch(requestCardStatements(cardId))
    .then(() =>
        dispatch(requestCardStatementDetails(cardId, statementId))
        .then(() => {
            const immMovements = getState().cardsStatementMovements;
            const hasMovements = immMovements.get(statementId) && immMovements.getIn([statementId, 'byId']).size > 0;

            if (!hasMovements || force){
                return fetchMovements(cardId, statementId, dispatch, getState);
            }

            return Promise.resolve();
        })
    );

module.exports = {
    requestMovements,
    requestNextPage
};
